// src/panels/aaa.jsx
import React from "react";
import { ReactComponent as A_Badge } from "../assets/icons/A_Badge.svg";
import { ReactComponent as AA_Badge } from "../assets/icons/AA_Badge.svg";
import { ReactComponent as AAA_Badge } from "../assets/icons/AAA_Badge.svg";

export default function AaaPanel({ value = 1.0, onSelectScale }) {
  return (
    <section
      style={{
        borderRadius: 5,
        background: "rgba(10,12,18,.20)",
        border: "1px solid rgba(28,46,73,.5)",
        boxShadow:
          "inset 0 -1px 3px rgba(255,255,255,.4), inset 0 3px 2px rgba(0,0,0,.5), 0 0px 1px rgba(0,0,0,.25)",
        padding: "6px 8px",
        boxSizing: "border-box",
        color: "#e6edf3",
        pointerEvents: "auto",            // wichtig: klickbar trotz Eltern 'none'
      }}
    >
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 2 }}>
        <FlatBtn
          title="Textgröße klein"
          active={value === 1.0}
          icon={<IconA size={20} />}
          onClick={() => onSelectScale?.(1.0)}
        />
        <FlatBtn
          title="Textgröße mittel"
          active={value === 1.25}
          icon={<IconAA size={20} />}
          onClick={() => onSelectScale?.(1.25)}
        />
        <FlatBtn
          title="Textgröße groß"
          active={value === 1.6}
          icon={<IconAAA size={20} />}
          onClick={() => onSelectScale?.(1.6)}
        />
      </div>
    </section>
  );
}

/* Flacher Button – Inline-Only: Hover = Orange, Aktiv = Grün */
function FlatBtn({ title, icon, active, onClick }) {
  const [hover, setHover] = React.useState(false);

  // Farben
  const BASE_BORDER = "rgba(255,255,255,.18)";
  const BASE_FG     = "rgb(218,218,218)";

  const ORANGE_BORDER = "#ff8800";
  const ORANGE_FG     = "#ffd3a4";
  const ORANGE_SHADOW =
    "0 0 0 0px rgba(255,136,0,.35), 0 0 10px rgba(255,136,0,.0), inset 0 0 0 9999px rgba(255,255,255,.0)";

  const GREEN_BORDER  = "#338f50";
  const GREEN_FG      = "#338f50";
  const GREEN_SHADOW  =
    "0 0 0 px rgba(59,229,127,.35), 0 0 12px rgba(59,229,127,.0), inset 0 0 0 9999px rgba(59,229,127,.05)";
  const GREEN_SHADOW_HOVER =
    "0 0 0 px rgba(59,229,127,.5), 0 0 14px rgba(59,229,127,.0), inset 0 0 0 9999px rgba(59,229,127,.0)";

  // Zustandsabhängige Werte
  const borderColor = active ? GREEN_BORDER : (hover ? ORANGE_BORDER : BASE_BORDER);
  const fgColor     = active ? GREEN_FG     : (hover ? ORANGE_FG     : BASE_FG);
  const boxShadow   = active ? (hover ? GREEN_SHADOW_HOVER : GREEN_SHADOW)
                             : (hover ? ORANGE_SHADOW : "none");

  return (
    <button
      type="button"
      onClick={onClick}
      title={title}
      aria-pressed={active}
      onPointerEnter={() => setHover(true)}
      onPointerLeave={() => setHover(false)}
      style={{
        all: "unset",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        height: 28,
        padding: "0 4px",
        boxSizing: "border-box",
        background: "transparent",
        borderRadius: 3,
        cursor: "pointer",
        minWidth: 0,
        border: `1px solid ${borderColor}`,
        color: fgColor,
        boxShadow,
        transition: "border-color 140ms ease, color 140ms ease, box-shadow 140ms ease",
      }}
    >
      {icon && (
    <span
      style={{ display: "block", lineHeight: 0, color: fgColor }}  // ⬅️ HIER Farbe setzen
    >
      {icon}
    </span>
  )}
    </button>
  );
}

function IconA({ size = 20, title }) {
  return <A_Badge width={size} height={size} aria-hidden={!title} aria-label={title} className="fgColor" />;
}
function IconAA({ size = 20, title }) {
  return <AA_Badge width={size} height={size} aria-hidden={!title} aria-label={title} className="fgColor" />;
}
function IconAAA({ size = 20, title }) {
  return <AAA_Badge width={size} height={size} aria-hidden={!title} aria-label={title} className="fcColor" />;
}
